const state = {
  token: "", 	//登录token
  information:""//信息
};


export default state


// WEBPACK FOOTER //
// ./src/store/state.js